var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ol',{staticClass:"list"},_vm._l((_vm.steps),function(step,index){return _c('li',{key:step.route,staticClass:"item"},[_c('router-link',{staticClass:"link",class:{
          'is-completed': step.completed
        },attrs:{"to":{ name: ("request-step-" + index) }}},[_vm._v(" "+_vm._s(step.title)+" ")])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }